export function useFunctionIfExists(el: any, f: string, cb: () => void): void {
  if (typeof el[f] === 'function') {
    cb();
  }
}
